import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    container: {
        position: 'relative'
    },
    itemText: {
        textAlign: 'left',
        fontFamily: Theme.regularFont,
        paddingTop: 9,
        fontSize: 18,
        letterSpacing: 0.7,
        color: Theme.primaryTextColor
    },
    itemSubText: {
        textAlign: 'left',
        fontFamily: Theme.regularFont,
        paddingTop: 2,
        fontSize: 15,
        letterSpacing: 0.4,
        color: Theme.secondaryTextColor
    },
    itemTextFocused: {},
    itemImageContainer: {
        position: 'relative'
    },
    itemImage: {
        width: '100%',
        height: '100%'
    },
    itemImageFocused: {},
    indicator: {
        position: 'absolute',
        bottom: 0,
        height: '3%'
    },
    icon: {
        zIndex: 10,
        position: 'absolute',
        top: '5%',
        left: '2%',
        width: '22%',
        height: '22%'
    },
    packageIcon: {
        zIndex: 10,
        position: 'absolute',
        bottom: '4%',
        left: '6%',
        width: Theme.BU * 1.3,
        height: Theme.BU * 1.3
    },
    ageRestrictedStyle: {
        backgroundColor: '#2E2F3190'
    },
    imageGradient: {
        zIndex: 1,
        flex: 1,
        position: 'absolute',
        height: '100%',
        width: '100%'
    },
    metadataText: {
        color: '#A4A4A4',
        fontSize: 13,
        marginTop: 2,
        fontFamily: Theme.regularFont
    },
    labelConteiner: {
        position: 'absolute',
        top: 4,
        right: 4,
        flex: 1
    }
};

export default StyleSheet.create(baseStyles);
